// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__3gMKQ","name":"ConsentHeader_name__1YE6v","birthday":"ConsentHeader_birthday__p0HnA","skeleton":"ConsentHeader_skeleton__2embL"};